import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51d233c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "courier-id" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "mt-8 rounded bg-white flex flex-col items-center justify-center py-3 px-4"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 select-none mt-2" }, "Загрузка данных о курьере...", -1))
const _hoisted_6 = {
  key: 1,
  class: "mt-8 rounded bg-white flex flex-col items-center justify-center py-3 px-4"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500 select-none" }, " При получении данных о курьере произошла ошибка ", -1))
const _hoisted_8 = { class: "mt-8 rounded bg-white flex items-center justify-between py-3 px-4" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_13 = { class: "mt-2 rounded bg-white" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b p-4 select-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-sm font-semibold" }, "Информация")
], -1))
const _hoisted_15 = { class: "p-4 grid grid-cols-3 gap-4" }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "ИИН", -1))
const _hoisted_18 = { class: "mt-1 font-medium" }
const _hoisted_19 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "ФИО", -1))
const _hoisted_21 = { class: "mt-1 font-medium" }
const _hoisted_22 = {
  key: 5,
  class: "flex flex-col"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Сектор диспетчера", -1))
const _hoisted_24 = { class: "mt-1 font-medium" }
const _hoisted_25 = {
  key: 7,
  class: "flex flex-col"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Телефон", -1))
const _hoisted_27 = { class: "mt-1 font-medium" }
const _hoisted_28 = {
  key: 9,
  class: "flex flex-col"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Тип оплаты", -1))
const _hoisted_30 = { class: "mt-1 font-medium" }
const _hoisted_31 = {
  key: 11,
  class: "flex flex-col"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Сумма оплаты", -1))
const _hoisted_33 = { class: "mt-1 font-medium" }
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Дата создания", -1))
const _hoisted_36 = { class: "mt-1 font-medium" }
const _hoisted_37 = {
  key: 13,
  class: "flex flex-col"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Название компании", -1))
const _hoisted_39 = { class: "mt-1 font-medium" }
const _hoisted_40 = {
  key: 15,
  class: "flex flex-col"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Смена", -1))
const _hoisted_42 = { class: "mt-1 font-medium" }
const _hoisted_43 = {
  key: 17,
  class: "flex flex-col"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Тип курьера", -1))
const _hoisted_45 = { class: "mt-1 font-medium" }
const _hoisted_46 = {
  key: 19,
  class: "flex flex-col"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Код 1С", -1))
const _hoisted_48 = { class: "mt-1 font-medium" }
const _hoisted_49 = { class: "mt-3 rounded bg-white" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b p-4 select-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-sm font-semibold" }, "Сведения об авто")
], -1))
const _hoisted_51 = { class: "p-4 grid grid-cols-3 gap-4" }
const _hoisted_52 = {
  key: 0,
  aclass: "text-sm text-gray-400"
}
const _hoisted_53 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Гос номер", -1))
const _hoisted_55 = { class: "mt-1 font-medium" }
const _hoisted_56 = { class: "flex flex-col" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Модель", -1))
const _hoisted_58 = { class: "mt-1 font-medium" }
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Тип машины", -1))
const _hoisted_61 = { class: "mt-1 font-medium" }
const _hoisted_62 = { class: "flex flex-col" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Компания", -1))
const _hoisted_64 = { class: "mt-1 font-medium" }
const _hoisted_65 = { class: "flex flex-col" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Кубатура", -1))
const _hoisted_67 = { class: "mt-1 font-medium" }
const _hoisted_68 = { class: "flex flex-col" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Объем", -1))
const _hoisted_70 = { class: "mt-1 font-medium" }
const _hoisted_71 = { class: "mt-3 rounded bg-white" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b p-4 select-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-sm font-semibold" }, "Документы")
], -1))
const _hoisted_73 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_courier_status = _resolveComponent("courier-status")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_courier_driver_licenses = _resolveComponent("courier-driver-licenses")!
  const _component_courier_identification_cards = _resolveComponent("courier-identification-cards")!
  const _component_sb_history = _resolveComponent("sb-history")!
  const _component_courier_schedule = _resolveComponent("courier-schedule")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Профиль" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _ctx.onBack
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_loader, { class: "primary" }),
          _hoisted_5
        ]))
      : (_ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_the_button, {
              class: "primary small mt-2",
              onClick: _ctx.loadCourier
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Обновить ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.state.courier.fullName), 1),
                _createVNode(_component_courier_status, {
                  status: _ctx.state.courier.status,
                  class: "ml-3"
                }, null, 8, ["status"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.isCanReject)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      loading: _ctx.reject_state.is_loading,
                      class: "red small text mr-3",
                      onClick: _ctx.rejectCourier
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(" Отказ ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isRenderOnCheckStatusButton)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      loading: _ctx.state.is_status_change_loading,
                      class: "yellow text small mr-3",
                      onClick: _ctx.setOnCheckStatus
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" На проверке(СБ) ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isRenderActiveStatusButton)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 2,
                      loading: _ctx.state.is_status_change_loading,
                      class: "green text small mr-3",
                      onClick: _ctx.setActiveStatus
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Активировать ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isRenderArchiveStatusButton)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 3,
                      loading: _ctx.state.is_status_change_loading,
                      class: "red text small mr-3",
                      onClick: _ctx.setArchiveStatus
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" В архив ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_the_button, {
                        disabled: _ctx.state.is_edit_loading,
                        class: "primary small text",
                        onClick: _ctx.toggleEdit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Отмена ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_the_button, {
                        disabled: _ctx.state.is_edit_loading,
                        class: "primary small ml-3",
                        onClick: _ctx.updateCourier
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Сохранить ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 0,
                      placeholder: "ИИН",
                      disabled: _ctx.state.is_edit_loading,
                      value: _ctx.edit_state.iin,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.edit_state.iin) = $event)),
                      "is-invalid": _ctx.edit_form$.iin.$error,
                      "valididation-errors": _ctx.edit_form$.iin.$errors
                    }, null, 8, ["disabled", "value", "is-invalid", "valididation-errors"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.state.courier.iin), 1)
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 2,
                      placeholder: "ФИО",
                      disabled: _ctx.state.is_edit_loading,
                      value: _ctx.edit_state.fullName,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.edit_state.fullName) = $event)),
                      "is-invalid": _ctx.edit_form$.fullName.$error,
                      "valididation-errors": _ctx.edit_form$.fullName.$errors
                    }, null, 8, ["disabled", "value", "is-invalid", "valididation-errors"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.state.courier.fullName), 1)
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 4,
                      class: "mt-2",
                      placeholder: "Сектор диспетчера",
                      value: _ctx.edit_state.dispatcherSectorId,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.edit_state.dispatcherSectorId) = $event)),
                      disabled: _ctx.state.is_edit_loading,
                      options: _ctx.dispatcher_sectors_state.list,
                      loading: _ctx.dispatcher_sectors_state.is_loading,
                      failed: _ctx.dispatcher_sectors_state.is_failed,
                      "is-invalid": _ctx.edit_form$.dispatcherSectorId.$error,
                      "valididation-errors": _ctx.edit_form$.dispatcherSectorId.$errors,
                      "error-text": "При получении списка секторов диспетчера произошла ошибка",
                      "search-without-refresh": "",
                      onRefresh: _ctx.loadDispatcherSectors
                    }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "valididation-errors", "onRefresh"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.state.courier.dispatcherSector.name), 1)
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 6,
                      placeholder: "Телефон",
                      disabled: _ctx.state.is_edit_loading,
                      value: _ctx.edit_state.phoneNumber,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.edit_state.phoneNumber) = $event)),
                      "is-invalid": _ctx.edit_form$.phoneNumber.$error,
                      "valididation-errors": _ctx.edit_form$.phoneNumber.$errors
                    }, null, 8, ["disabled", "value", "is-invalid", "valididation-errors"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.state.courier.phoneNumber), 1)
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 8,
                      class: "mt-2",
                      value: _ctx.edit_state.paymentRateType,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.edit_state.paymentRateType) = $event)),
                      placeholder: "Тип оплаты",
                      "is-invalid": _ctx.edit_form$.paymentRateType.$error,
                      "valididation-errors": _ctx.edit_form$.paymentRateType.$errors,
                      disabled: _ctx.state.is_edit_loading,
                      loading: false,
                      options: _ctx.CourierPaymentTypes,
                      searchable: false,
                      label: "name"
                    }, null, 8, ["value", "is-invalid", "valididation-errors", "disabled", "options"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("p", _hoisted_30, [
                        (_ctx.state.courier.paymentRateType)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.courier.paymentRateType.title), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("-")
                            ], 64))
                      ])
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 10,
                      placeholder: "Сумма оплаты",
                      disabled: _ctx.state.is_edit_loading,
                      value: _ctx.edit_state.paymentAmount,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.edit_state.paymentAmount) = $event)),
                      "is-invalid": _ctx.edit_form$.paymentAmount.$error,
                      "valididation-errors": _ctx.edit_form$.paymentAmount.$errors
                    }, null, 8, ["disabled", "value", "is-invalid", "valididation-errors"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.state.courier.paymentAmount), 1)
                    ])),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.state.courier.createdAt), 1)
                ]),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 12,
                      class: "mt-2",
                      placeholder: "Компания",
                      value: _ctx.edit_state.companyId,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.edit_state.companyId) = $event)),
                      "is-invalid": _ctx.edit_form$.companyId.$error,
                      "valididation-errors": _ctx.edit_form$.companyId.$errors,
                      disabled: _ctx.state.is_edit_loading,
                      options: _ctx.companies_state.list,
                      loading: _ctx.companies_state.is_loading,
                      failed: _ctx.companies_state.is_failed,
                      "error-text": "При получении списка компаний произошла ошибка",
                      "search-without-refresh": "",
                      onRefresh: _ctx.loadCompanies
                    }, null, 8, ["value", "is-invalid", "valididation-errors", "disabled", "options", "loading", "failed", "onRefresh"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.state.courier.company.name), 1)
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 14,
                      class: "mt-2",
                      placeholder: "Смена",
                      value: _ctx.edit_state.scheduleTypeId,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.edit_state.scheduleTypeId) = $event)),
                      "is-invalid": _ctx.edit_form$.scheduleTypeId.$error,
                      "valididation-errors": _ctx.edit_form$.scheduleTypeId.$errors,
                      disabled: _ctx.state.is_edit_loading,
                      options: _ctx.schedule_types_state.list,
                      loading: _ctx.schedule_types_state.is_loading,
                      failed: _ctx.schedule_types_state.is_failed,
                      searchable: false,
                      "error-text": "При получении списка смен произошла ошибка",
                      onRefresh: _ctx.loadScheduleTypes
                    }, {
                      "selected-option": _withCtx(({ option }) => [
                        _createTextVNode(_toDisplayString(option.workTimeFrom) + " - " + _toDisplayString(option.workTimeUntil) + " (" + _toDisplayString(option.title) + ") ", 1)
                      ]),
                      option: _withCtx(({ option }) => [
                        _createTextVNode(_toDisplayString(option.workTimeFrom) + " - " + _toDisplayString(option.workTimeUntil) + " (" + _toDisplayString(option.title) + ") ", 1)
                      ]),
                      _: 1
                    }, 8, ["value", "is-invalid", "valididation-errors", "disabled", "options", "loading", "failed", "onRefresh"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("p", _hoisted_42, [
                        (_ctx.state.courier.schedule)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.courier.schedule.workTimeFrom) + " - " + _toDisplayString(_ctx.state.courier.schedule.workTimeUntil) + " (" + _toDisplayString(_ctx.state.courier.schedule.title) + ") ", 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ])
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 16,
                      class: "mt-2",
                      placeholder: "Тип курьера",
                      value: _ctx.edit_state.typeIds,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.edit_state.typeIds) = $event)),
                      "is-invalid": _ctx.edit_form$.typeIds.$error,
                      "valididation-errors": _ctx.edit_form$.typeIds.$errors,
                      disabled: _ctx.state.is_edit_loading,
                      options: _ctx.types_state.list,
                      loading: _ctx.types_state.is_loading,
                      failed: _ctx.types_state.is_failed,
                      searchable: false,
                      multiselect: "",
                      label: "title",
                      "error-text": "При получении списка типов курьера произошла ошибка",
                      onRefresh: _ctx.loadCourierTypes
                    }, null, 8, ["value", "is-invalid", "valididation-errors", "disabled", "options", "loading", "failed", "onRefresh"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("p", _hoisted_45, [
                        (_ctx.state.courier.types.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.courier.types.map((type) => type.title).join(', ')), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ])
                    ])),
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 18,
                      placeholder: "Код 1С",
                      disabled: _ctx.state.is_edit_loading,
                      value: _ctx.edit_state.code1C,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.edit_state.code1C) = $event))
                    }, null, 8, ["disabled", "value"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.state.courier.code1C), 1)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                (_ctx.state.is_edit_mode)
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 0,
                      class: "mt-2",
                      placeholder: "Машина",
                      value: _ctx.edit_state.carId,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.edit_state.carId) = $event)),
                      "is-invalid": _ctx.edit_form$.carId.$error,
                      "valididation-errors": _ctx.edit_form$.carId.$errors,
                      disabled: _ctx.state.is_edit_loading,
                      options: _ctx.cars_state.list,
                      loading: _ctx.cars_state.is_loading,
                      failed: _ctx.cars_state.is_failed,
                      "search-by": "number",
                      "error-text": "При получении списка машин произошла ошибка",
                      "search-without-refresh": "",
                      onRefresh: _ctx.loadCars
                    }, {
                      "selected-option": _withCtx(({ option }) => [
                        (option.company)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number) + " (" + _toDisplayString(option.company.name) + ") ", 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                            ], 64))
                      ]),
                      option: _withCtx(({ option }) => [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", null, _toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1),
                          (option.company)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(option.company.name), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["value", "is-invalid", "valididation-errors", "disabled", "options", "loading", "failed", "onRefresh"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.state.courier.car.number), 1)
                    ])),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.state.courier.car.model), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.state.courier.car.carType.title), 1)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.state.courier.car.company.name), 1)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.state.courier.car.carType.capacity), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.state.courier.car.carType.volume), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_courier_driver_licenses, {
                  "is-can-delete": _ctx.state.is_edit_mode,
                  "driver-licenses": _ctx.state.courier.driverLicenses,
                  "courier-id": _ctx.courier_id,
                  onFilesUploaded: _ctx.loadCourier,
                  onFileDeleted: _ctx.loadCourier
                }, null, 8, ["is-can-delete", "driver-licenses", "courier-id", "onFilesUploaded", "onFileDeleted"]),
                _createVNode(_component_courier_identification_cards, {
                  class: "mt-4",
                  "is-can-delete": _ctx.state.is_edit_mode,
                  "identification-cards": _ctx.state.courier.identificationCards,
                  "courier-id": _ctx.courier_id,
                  onFilesUploaded: _ctx.loadCourier
                }, null, 8, ["is-can-delete", "identification-cards", "courier-id", "onFilesUploaded"])
              ])
            ]),
            _createVNode(_component_sb_history, {
              class: "mt-3",
              identifier: _ctx.state.courier.iin,
              type: 2
            }, null, 8, ["identifier"]),
            _createVNode(_component_courier_schedule, { "courier-id": _ctx.courier_id }, null, 8, ["courier-id"])
          ], 64))
  ]))
}